import { useState } from 'react';
import _get from 'lodash/get';
import _camelCase from 'lodash/camelCase';
import { useIntl } from 'react-intl';
/* eslint-disable import/prefer-default-export */
const GRAPHQL_URL = __GRAPHQL_URL__; // eslint-disable-line no-undef

function useMutation({
  query,
  token,
}) {
  const { formatMessage: t } = useIntl();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [data, setData] = useState(null);

  // eslint-disable-next-line no-param-reassign
  const TIMEOUT_DELAY_MS = 5000;

  const exec = async (variables) => {
    const controller = new AbortController();
    const { signal } = controller;

    setLoading(true);
    setErrors(null);
    setData(null);

    // Abort the request after timeout
    const timeoutId = setTimeout(() => {
      controller.abort();
      // setErrors({ network: `Request timed out after ${TIMEOUT_DELAY_MS / 1000} seconds` });
    }, TIMEOUT_DELAY_MS);

    try {
      const response = await fetch(GRAPHQL_URL, {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.app.v4+json',
          ...(token ? { Authorization: `Bearer ${token}` } : null),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query,
          variables,
        }),
        signal,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      if (result.errors && result.errors.length > 0) {
        const newErrors = {};
        result.errors.forEach((error) => {
          const specificErrors = _get(error, 'extensions.path', null) || _get(error, 'path', null);
          if (specificErrors) {
            specificErrors.forEach((specificError) => {
              const translationKey = `formError.${specificError}.${_camelCase(error.message)}`;
              const message = t({ id: translationKey });
              newErrors[specificError] = message;
            });
            return;
          }

          if (error && error.message) {
            const translationKey = `error.${_camelCase(error.message)}`;
            const message = t({ id: translationKey });
            newErrors.global = message;
          } else {
            newErrors.global = true;
          }
        });
        setErrors(newErrors);
        setLoading(false);
        return;
      }

      setData(result.data);
      clearTimeout(timeoutId);
    } catch (e) {
      if (e.name === 'AbortError') {
        // eslint-disable-next-line no-console
        console.warn('Request aborted');
      } else {
        // eslint-disable-next-line no-console
        console.error('Error:', e);
        setErrors({ network: String(e) });
        clearTimeout(timeoutId);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    exec,
    loading,
    errors,
    data,
  };
}

export default useMutation;



// WEBPACK FOOTER //
// ./hooks/useMutation.js